import React from 'react';
import {Icon} from "in-touch-icons";
import { connect } from 'react-redux';
import {openPlayer} from '../../../../actions/media/media'
import { PrismicDocumentHelper } from '../../../../helpers/prismicHelpers/PrismicHelpers';
import { PodcastsListHelper } from '../../../../helpers/prismicHelpers/prismic-custom-helpers/HomepageCardHelpers';

class SeriesPodcastsCard extends React.Component{

    state = ({
        podcast: ''
    })

    async getEpisodes(){
        if( !this.props.episodeData ){ return };
        const ids = this.props.episodeData.map(episode => {
            return episode.podcast_episode.id
        })
        PrismicDocumentHelper('document.id',ids, false, 'in')
        .then(data => PodcastsListHelper(data))
        .then(data => this.setState({ podcast: data}))
    }
    render() {
    if(this.props.episodeData)
    {
        this.getEpisodes();
    }

    const {episode, title, description } = this.props.podcastsData;
    const clever = this.props.clever === true ? 'clever' : ''; 
    let card;

    switch(this.props.length)
    {
        case 1: card = ''
            break;
        case 2: card = 'col-sm-6'
            break;
        case 3: card = 'col-xl-4'
            break;
        default: card = 'col-sm-6 col-xl-3'
    }
    return (
        <div className={`col-12 ${card} base-card podcast-card ${clever}`}>
            <button className="card-inner" onClick={() => this.props.openPlayer(this.state.podcast)}>
                <div className="theme-podcast-head">
                    <div className="play-wrapper">
                        <Icon iconName='play' svgClass="play-img"/>
                    </div>
                </div>
                <div className="theme-podcast-body">
                    <h3 className="heading-three color-1 episode">{episode}</h3>
                    <h3 className="heading-three card-title">{title}</h3>
                    <p className="body-copy podcast-copy">{description}</p>
                    <div className="body-foot">
                        <Icon iconName='episode'/>
                        {this.state.podcast && <p className="body-copy">{this.state.podcast.podcastsList.length} Episodes</p>}
                    </div>
                </div>
            </button>
        </div>

    );
    }
};


const mapDispatchToProps = dispatch => {
	return {
        openPlayer: (tracks) => dispatch(openPlayer(tracks))
    };
}
export default connect(null, mapDispatchToProps)(SeriesPodcastsCard);


// WEBPACK FOOTER //
// src/client/components/dashboardNew/components/cards/SeriesPodcastsCard.js